import Popup from '../popup'

export default class SlideOver extends Popup {
	static title = 'slide-over'
}
